import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import useUsers from '@/components/UsersSearch/hooks/useUsers';

import { InstructorErrorType } from './types';
import UserCard from './UserCard';

function SelectedInstructors({
  instructorIds,
  error,
  onDelete,
  onReplace,
  disabled,
}: {
  instructorIds?: string[];
  error?: InstructorErrorType;
  onDelete: (id: string) => void;
  onReplace: () => void;
  disabled?: boolean;
}) {
  const { data: users, isFetching } = useUsers({
    ids: instructorIds,
    pause: !instructorIds?.length,
    crossSubWorkspace: true,
  });

  if (!instructorIds?.length || isFetching || !users?.length) {
    return null;
  }

  const showError = !!error;

  return (
    <Box className="mb-12 space-y-12">
      {users.map((user) => {
        const isError = showError && error.invalidInstructorsIds?.some((id) => id === user.id);

        return (
          <Box key={user.id}>
            <UserCard
              key={user.id}
              className={cn(
                'rounded-8 border p-20',
                isError ? 'border-border-error-dark' : 'border-border',
              )}
              disabled={disabled}
              user={user}
              onAction={{ onDelete, onReplace }}
            />
            {isError ? (
              <Typography className="pt-8 ps-8" color="text-text-error" variant="body-short-03">
                {error.errorMessage}
              </Typography>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}

export default SelectedInstructors;
